import { format } from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47724 */
import * as React from 'react';
import { observer } from 'mobx-react';
import getSearchFeedbackCustomTags from '../helpers/getSearchFeedbackCustomTags';
import sendSearchFeedback from '../helpers/sendSearchFeedback';
import UserVoiceFeedbackType from 'owa-service/lib/contract/UserVoiceFeedbackType';
import { ControlIcons } from 'owa-control-icons';
import { DialogResponse } from 'owa-confirm-dialog';

import { HeaderCharmType, toggleCharm } from 'owa-header-store';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazySetSelectedPivot } from 'owa-diagnostics';
import { Link } from 'office-ui-fabric-react/lib/components/Link';
import { SEARCH_DIAGNOSTICS_PANEL_KEY, searchDiagnosticsStore } from 'owa-search-diagnostics';
import { lazyShowUserVoiceSuggestionDialog } from 'owa-uservoice';
import {
    SearchInContextFeedbackProps,
    UserVoiceSearchTeam,
} from '../components/SearchInContextFeedback';

const styles = require('./SearchInContextFeedbackDialog.scss');
const classNames = require('classnames');

// this feature can NEVER ship beyond MSIT since it contains PII,
// so we store our strings locally (so that they don't get localized)
const unlocalizedStrings = {
    dialogTitle: 'What issues did you encounter?',
    feedbackCommentsPlaceholder: 'Tell us what happened or how we can improve',
    feedbackLauncherLink: 'Submit search feedback',
    linkSeparator: '|',
    viewDiagnosticsLink: 'View diagnostics',
    searchTimeText: '({0} sec)',
    ticketTitle: 'New Ticket for Search In-Context Feedback',
};

@observer
export default class SearchInContextFeedbackDialog extends React.Component<
    SearchInContextFeedbackProps,
    {}
> {
    render() {
        const lastSearchRequestTime = this.getLastSearchRequestTimeInSeconds();
        const searchTimeString = format(unlocalizedStrings.searchTimeText, lastSearchRequestTime);

        return (
            <div className={classNames(this.props.cssClass, styles.linkContainer)}>
                <Link
                    onClick={() => this.showSearchInContextFeedbackDialog(this.props.userVoiceTeam)}
                    styles={() => ({
                        root: {
                            alignItems: 'center',
                            display: 'flex',
                            fontSize: '12px',
                            marginRight: '16px',
                        },
                    })}>
                    <Icon iconName={ControlIcons.Info} className={styles.linkIcon} />
                    {unlocalizedStrings.feedbackLauncherLink}
                </Link>

                {isFeatureEnabled('fwk-devTools') && (
                    <Link
                        styles={() => ({
                            root: {
                                alignItems: 'center',
                                display: 'flex',
                                fontSize: '12px',
                            },
                        })}
                        onClick={() => {
                            toggleCharm(HeaderCharmType.DiagnosticsCharm);
                            lazySetSelectedPivot
                                .import()
                                .then(setSelectedPivot =>
                                    setSelectedPivot(SEARCH_DIAGNOSTICS_PANEL_KEY)
                                );
                        }}>
                        <Icon iconName={ControlIcons.DeveloperTools} className={styles.linkIcon} />
                        {unlocalizedStrings.viewDiagnosticsLink}{' '}
                        {lastSearchRequestTime ? searchTimeString : ''}
                    </Link>
                )}
            </div>
        );
    }

    private async showSearchInContextFeedbackDialog(userVoiceTeam: UserVoiceSearchTeam) {
        const response = await (await lazyShowUserVoiceSuggestionDialog.import())({
            title: unlocalizedStrings.ticketTitle,
            feedbackType: UserVoiceFeedbackType.SearchInContextFeedback,
            header: unlocalizedStrings.dialogTitle,
            blurbElement: <div />,
            textAreaPlaceHolder: unlocalizedStrings.feedbackCommentsPlaceholder,
            customTags: getSearchFeedbackCustomTags(userVoiceTeam),
        });

        if (response === DialogResponse.ok) {
            sendSearchFeedback(userVoiceTeam);
        }
    }

    private getLastSearchRequestTimeInSeconds = (): number => {
        const searchInstrumentationEntries = searchDiagnosticsStore.searchInstrumentationList
            .slice()
            .reverse();

        for (const instrumentation of searchInstrumentationEntries) {
            if (
                instrumentation.PageNumber == 0 &&
                instrumentation.SearchQueryId == this.props.currentSearchQueryId
            ) {
                return instrumentation.ClientJSEndToEndTime / 1000.0;
            }
        }

        return 0;
    };
}
